import { render, staticRenderFns } from "./Impressum.vue?vue&type=template&id=774d2c6c&scoped=true&"
var script = {}
import style0 from "./Impressum.vue?vue&type=style&index=0&id=774d2c6c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "774d2c6c",
  null
  
)

export default component.exports